import NavigationMenuItem from './NavigationMenuItem';
import NavigationScope from './NavigationScope';

export default class NavigationMenu {
    sysAdminMenuItems: NavigationMenuItem[] = [];
    agencyMenuItems: NavigationMenuItem[] = []
    companyMenuItems: NavigationMenuItem[] = [];
    scope: NavigationScope = NavigationScope.NotSet;
}